export const FRAMEWORK_IDS = {
  // wiz isr staging framework for sandbox env
  WIZ_ISR_STAGING_FRAMEWORK_SANDBOX: 'dcbb53cf-a5ee-49be-ac6f-7586db5783af',

  // wiz isr staging framework for prod
  WIZ_ISR_STAGING_FRAMEWORK: '4d08782d-a858-47b1-8f7b-6842fcfb00d4',
};
